import { render, staticRenderFns } from "./FeaturesWorld.vue?vue&type=template&id=a6a4c6a4"
import script from "./FeaturesWorld.vue?vue&type=script&lang=js"
export * from "./FeaturesWorld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports